import { combineReducers } from 'redux';
import authReducer from './auth.reducer';
import loadingReducer from './sagasstatus.reducer';
import navigation from './navigable.reducer';
import agendaReducer from './agenda/agenda.reducer';


const reducer = combineReducers({
  auth: authReducer,
  navigation,
  sagas: loadingReducer,
  agenda: agendaReducer,
});

export default reducer;
